import { render } from "./schduleAppointmentComponent.vue?vue&type=template&id=23a28048"
import script from "./schduleAppointmentComponent.vue?vue&type=script&lang=js"
export * from "./schduleAppointmentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__